import moment from 'moment';
import React from 'react';
import { array, bool, func, object, oneOfType, string } from 'prop-types';

import { filterUsers } from '../../utils';
import { TaskForm } from '../tasks-modal/task-form';
import { ContentWrapper, FormFieldActions, FormFieldButton } from './styled-components';

export const AddTaskContent = ({
  users,
  addTask,
  createTask,
  setFieldsValue,
  requestAssignees,
  getFieldDecorator,
  cancelCreateAndEditTask,
}) => addTask && (
  <ContentWrapper>
    <TaskForm
      form={{ getFieldDecorator, setFieldsValue }}
      requestAssignees={requestAssignees}
      setSelectedUser={() => {}}
      users={filterUsers(users.items)}
      onSubmit={createTask}
      actionButtons={
        <FormFieldActions>
          <FormFieldButton onClick={createTask}>Save</FormFieldButton>
          <FormFieldButton
            onClick={cancelCreateAndEditTask}
            cancel
          >Cancel changes
          </FormFieldButton>
        </FormFieldActions>}
    />
  </ContentWrapper>);

AddTaskContent.propTypes = {
  users: object.isRequired,
  addTask: bool.isRequired,
  createTask: func.isRequired,
  setFieldsValue: func.isRequired,
  requestAssignees: array.isRequired,
  getFieldDecorator: func.isRequired,
  cancelCreateAndEditTask: func.isRequired,
};


export const EditTaskContent = ({
  users,
  taskId,
  editTask,
  tasksList,
  updateTask,
  setFieldsValue,
  getFieldDecorator,
  cancelCreateAndEditTask,
}) => editTask && (
  <ContentWrapper>
    <TaskForm
      form={{ getFieldDecorator, setFieldsValue }}
      setSelectedUser={() => {
      }}
      users={filterUsers(users.items)}
      onSubmit={updateTask}
      taskPriority={tasksList[taskId].taskPriority}
      description={tasksList[taskId] ? tasksList[taskId].description : ''}
      title={tasksList[taskId] ? tasksList[taskId].title : ''}
      dueDate={tasksList[taskId] ? (moment(tasksList[taskId].dueDate)) : ''}
      dueTime={tasksList[taskId] ? tasksList[taskId].dueTime : ''}
      selectedUser={tasksList[taskId] ? tasksList[taskId].assignedTo.id : ''}
      isUpdating
      actionButtons={
        <FormFieldActions>
          <FormFieldButton onClick={updateTask}>Save</FormFieldButton>
          <FormFieldButton
            onClick={cancelCreateAndEditTask}
            cancel
          >Cancel changes
          </FormFieldButton>
        </FormFieldActions>}
    />
  </ContentWrapper>
);

EditTaskContent.propTypes = {
  users: object.isRequired,
  taskId: oneOfType([
    string, object,
  ]),
  editTask: bool.isRequired,
  tasksList: array.isRequired,
  updateTask: func.isRequired,
  setFieldsValue: func.isRequired,
  getFieldDecorator: func.isRequired,
  cancelCreateAndEditTask: func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modals/change-status/tasks.js